import $ from 'jquery';

$(document).ready(() => {
  if ($('body#index').length) {
    $('.old-tv').on('click', function(){
      var this_link = $(this).data('href');
      window.open(this_link);
    });
  }
});
